// src/components/NAAC.js
import React from 'react';

const NAAC = () => {
  return (
    <div className="naac-container">
      <h2>NAAC Accreditation</h2>
      <p>
        Sumatidevi Tompe Institute is committed to achieving excellence through quality assessment and accreditation. We are actively working towards NAAC (National Assessment and Accreditation Council) accreditation, which evaluates institutions on various parameters of quality education.
      </p>
      <p>
        This accreditation is a testament to our commitment to maintaining high standards in teaching-learning, research, infrastructure, and governance.
      </p>
  
    </div>
  );
};

export default NAAC;